// extracted by mini-css-extract-plugin
module.exports = {"featuresRow":"features_featuresRow__3my7W","feature":"features_feature__1tRwz"};